export const HOME_FAQ_ITEMS = [
  {
    question: 'Qu’est-ce que Leagora ?',
    answer:
      'Leagora est un socle vidéo métier permettant d’intégrer la vidéo dans les parcours professionnels : support client, diagnostic terrain, rendez-vous, réunions, formation ou diffusion live. Contrairement à un simple outil de visioconférence, Leagora permet de construire des parcours vidéo adaptés à votre activité, intégrés à vos outils et hébergés selon vos exigences.',
  },
  {
    question: 'Leagora est-il un simple outil de visioconférence ?',
    answer:
      'Non. Leagora conçoit et déploie des infrastructures vidéo métier WebRTC intégrables aux parcours professionnels. Les usages (assistance client, rendez-vous, réunion, live, QR code terrain) sont portés par des produits dédiés du groupe, avec API vidéo et intégration sur mesure lorsque votre SI l’exige.',
  },
  {
    question: 'Quelle technologie sous-tend l’infrastructure Leagora ?',
    answer:
      'WebRTC avec architecture SFU pour la montée en charge, serveurs STUN/TURN pour les réseaux d’entreprise, signalisation sécurisée et composants open source. L’expérience participant s’exécute dans le navigateur.',
  },
  {
    question: 'Où sont hébergées les infrastructures vidéo Leagora ?',
    answer:
      'Les déploiements peuvent s’effectuer sur une offre cloud en France ou en on-premise sur l’infrastructure client, selon la politique de résidence des données. Les engagements précis sont définis contractuellement.',
  },
  {
    question: 'Peut-on intégrer la vidéo Leagora via API ?',
    answer:
      'Oui. L’infrastructure expose des API vidéo et des options d’intégration navigateur (lien, iframe, SDK) pour connecter la communication temps réel à un portail, un CRM ou une application métier existante.',
  },
];

export const HOME_FAQ_ITEMS_EN = [
  {
    question: 'What is Leagora?',
    answer:
      'Leagora is a business video platform that embeds video into professional journeys: customer support, field diagnostics, appointments, meetings, training, or live broadcasts. Unlike a standalone videoconferencing tool, Leagora lets you build video journeys tailored to your business, integrated with your tools, and hosted to match your requirements.',
  },
  {
    question: 'Is Leagora just a videoconferencing tool?',
    answer:
      'No. Leagora designs and deploys WebRTC business video infrastructure integrated into professional workflows. Use cases (customer support, appointments, meetings, live streaming, field QR codes) are delivered by dedicated group products, with video API and custom integration when your IT stack requires it.',
  },
  {
    question: 'What technology powers Leagora infrastructure?',
    answer:
      'WebRTC with SFU architecture for scale, STUN/TURN servers for enterprise networks, secure signaling, and open-source components. The participant experience runs in the browser.',
  },
  {
    question: 'Where is Leagora video infrastructure hosted?',
    answer:
      'Deployments can run on a France cloud offering or on-premise on the customer infrastructure, depending on data residency policy. Specific commitments are defined contractually.',
  },
  {
    question: 'Can Leagora video be integrated via API?',
    answer:
      'Yes. The infrastructure exposes video APIs and browser integration options (link, iframe, SDK) to connect real-time communication to a portal, CRM, or existing business application.',
  },
];

export function getHomeFaqItems(locale = 'fr') {
  return locale === 'en' ? HOME_FAQ_ITEMS_EN : HOME_FAQ_ITEMS;
}
